import { lazy } from 'react';

const Login = lazy(() => import('@/screens/Authentication/Login'));
const ResetPassword = lazy(() => import('@/screens/Authentication/ResetPassword'));
const NotFound = lazy(() => import('@/screens/NotFound'));

export default [
    {
        path: '/login',
        key: 'LOGIN',
        exact: true,
        component: Login,
        accessor: 'login',
    },
    {
        path: '/reset-password',
        key: 'RESET_PASSWORD',
        exact: true,
        component: ResetPassword,
        accessor: 'resetPassword',
    },
    {
        path: '/not-found',
        key: 'NOT_FOUND',
        exact: true,
        component: NotFound,
        accessor: 'notFound',
    },
];
